import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

var getGroups = function getGroups(groupBy, items) {
  return groupBy ? Array.from(new Set(items.map(function (item) {
    return groupBy(item);
  }))) : [void 0];
};

var getItemsByGroup = function getItemsByGroup(groupBy, groups, items) {
  return groups.map(function (group) {
    return {
      group: group,
      items: groupBy ? items.filter(function (item) {
        return groupBy(item) === group;
      }) : items
    };
  });
};

export { getGroups, getItemsByGroup };